import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AlertBar from '@/components/AlertBar';
import Navbar from '@/components/Navbar';
import OPPSection from '@/components/OPPSection';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import NewsSection from '@/components/NewsSection';
import DzialajLokalnieSection from '@/components/DzialajLokalnieSection';
import GallerySection from '@/components/GallerySection';
import DzialamySection from '@/components/DzialamySection';
import ProjectsSection from '@/components/ProjectsSection';
import DocumentsSection from '@/components/DocumentsSection';
import SamorzadySection from '@/components/SamorzadySection';
import PartnersSection from '@/components/PartnersSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import BackToTop from '@/components/BackToTop';
import DevErrorPanel from '@/components/DevErrorPanel';
import PageSeo from '@/components/seo/PageSeo';

const FAQ_ITEMS = [
  { q: 'Czym jest grupa nieformalna?', a: 'Grupa nieformalna to minimum trzy osoby, które wspólnie realizują działania społeczne, ale nie mają osobowości prawnej. Mogą złożyć wniosek przez „patrona" (lokalną organizację z osobowością prawną) albo bezpośrednio do nas w ramach Inicjatywy Działaj Lokalnie.' },
  { q: 'Czym jest Inicjatywa Działaj Lokalnie?', a: 'To forma wsparcia dla grup nieformalnych, które nie mają patrona z osobowością prawną. SKIL nie przekazuje wtedy pieniędzy bezpośrednio, lecz sam ponosi koszty realizacji działań zgodnie z opisem projektu i budżetem. Podstawą współpracy jest umowa cywilnoprawna. W tej formie nie obowiązuje wymóg wkładu finansowego.' },
  { q: 'Ile wniosków mogę złożyć?', a: 'Liczba składanych wniosków nie jest ograniczona, ale komisja grantowa przyzna tylko jedną dotację danej grupie realizującej projekt. Organizacja może otrzymać dofinansowanie na własny projekt oraz dodatkowo na inicjatywy zgłoszone w imieniu różnych grup nieformalnych.' },
  { q: 'Co to jest „dobro wspólne"?', a: 'Dobro wspólne to wszystko, z czego korzystamy razem i za co jesteśmy współodpowiedzialni — czyste powietrze, bezpieczeństwo, park, miejsce spotkań, aktywność młodzieży. Projekt powinien tworzyć lub wzmacniać takie zasoby w Twojej społeczności.' },
  { q: 'Czy działania sportowe się kwalifikują?', a: 'Tak, ale tylko wtedy, gdy są częścią szerszego projektu aktywizującego społeczność i przyczyniają się do trwałych rezultatów. Sama seria treningów dla zawodników nie kwalifikuje się — w programie chodzi o budowanie wspólnoty.' },
  { q: 'Czy czynsz i koszty administracyjne mogą być wkładem własnym?', a: 'Tak, ale tylko proporcjonalnie do udziału projektu w kosztach stałych organizacji. Jeśli prowadzisz równolegle kilka projektów, podziel koszty (np. czynszu) między nie i wykaż część przypadającą na projekt grantowy jako wkład usługowy.' },
  { q: 'Czy mogę równolegle realizować inny projekt PAFW?', a: 'Tak. Grantobiorcy mogą prowadzić równolegle inne projekty finansowane przez Polsko-Amerykańską Fundację Wolności, pod warunkiem że środki z tych programów nie są wykazane jako wkład własny finansowy do projektu Działaj Lokalnie.' },
  { q: 'Jakie tematy mogą poruszać projekty?', a: 'Edukacja, kultura, sport (jako część aktywizacji), ekologia, ochrona zdrowia, pomoc społeczna, bezpieczeństwo, wsparcie osób z niepełnosprawnościami, wolontariat, ochrona dziedzictwa, promocja praw kobiet i wiele innych.' },
];

const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    // Wait for sections to mount
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
    return () => clearTimeout(t);
  }, [location.hash, location.key]);

  return (
    <div className="min-h-screen">
      <PageSeo
        title="Kuźnia Inicjatyw Lokalnych w Lisewie — Działaj Lokalnie"
        description="Stowarzyszenie Kuźnia Inicjatyw Lokalnych w Lisewie — działamy od 2003 roku. Ośrodek Działaj Lokalnie, granty i projekty społeczne w Ziemi Chełmińskiej."
        path="/"
        jsonLd={FAQ_SCHEMA}
      />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg"
      >
        Przejdź do treści
      </a>
      <AlertBar />
      <Navbar />
      <main id="main">
        <HeroSection />
        <AboutSection />
        <NewsSection />
        <DzialajLokalnieSection />
        <OPPSection />
        <GallerySection />
        <DzialamySection />
        <ProjectsSection />
        <DocumentsSection />
        <SamorzadySection />
        <PartnersSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
      <DevErrorPanel />
    </div>
  );
};

export default Index;
